import { createRouter, createWebHistory } from "vue-router";

const routes = [
  // {
  //     path: "/",
  //     name: "firstPage",
  //     component: () =>
  //         import('@/view/firstPage.vue'),
  //     children: [
  //         {
  //             path: "/middlePage",
  //             name: "middlePage",
  //             component: () =>
  //                 import('@/view/middlePage.vue')
  //         },
  //             // 其他页面组件的路由规则
  //         {
  //             path: '/newsMsg',
  //             name: 'newsMsg',
  //             component: () =>
  //                 import('@/view/newsMsg.vue')
  //         },
  //     ]
  // },
  // {
  //     path: "/middlePage",
  //     name: "middlePage",
  //     component: () =>
  //         import('@/view/middlePage.vue')
  // },
  {
    //生态理论
    path: "/mingPinTang",

    name: "mingPinTang",
    component: () => import("@/components/mingPinTang.vue"),
  },
  {
    //受恶意
    path: "/",

    name: "main",
    component: () => import("@/view/main.vue"),
  },

  {
    //生态理论
    path: "/ecologyTheory",
    name: "ecologyTheory",
    component: () => import("@/components/ecologyTheory.vue"),
  },
  {
    //生态名品堂
    path: "/mainPage",

    name: "mainPage",
    component: () => import("@/view/mainPage.vue"),
    // children: [
    //     {
    //          path: '/newsMsg',
    //          name: 'newsMsg',
    //          component: () =>
    //             import('@/view/newsMsg.vue')
    //     },
    // ]
  },
  {
    path: "/bigScreen",
    name: "bigScreen",
    component: () => import("@/components/bigScreen.vue"),
  },
  {
    path: "/productMsg",
    name: "productMsg",
    component: () => import("@/components/productMsg.vue"),
  },
  {
    //监督管理
    path: "/serveMsg",
    name: "serveMsg",
    component: () => import("@/components/serveMsg.vue"),
  },
  {
    //典型案例
    path: "/regularMsg",
    name: "regularMsg",
    component: () => import("@/components/regularMsg.vue"),
  },
  {
    //政策支持
    path: "/policyMsg",
    name: "policyMsg",
    component: () => import("@/components/policyMsg.vue"),
  },
  {
    path: "/aboutMsg",
    name: "aboutMsg",
    component: () => import("@/components/aboutMsg.vue"),
  },
  {
    path: "/proDetail",
    name: "proDetail",
    component: () => import("@/view/proDetail.vue"),
  },
  {
    path: "/noticeMore",
    name: "noticeMore",
    component: () => import("@/view/noticeMore.vue"),
  },
  {
    path: "/newsMsg",
    name: "newsMsg",
    component: () => import("@/view/newsMsg.vue"),
  },

  {
    //缤纷泗洪
    path: "/colorfulMsg",
    name: "colorfulMsg",
    component: () => import("@/components/colorfulMsg.vue"),
  },
  // {
  //     path: '/headNavigation',
  //     component: headNavigation, // 使用共享布局组件
  //     children: [
  //       {
  //         path: '/newsMsg',
  //         component: newsMsg // 首页组件
  //       },
  //       // 其他页面组件的路由规则
  //     ]
  //   },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
